/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Built_ForInputs */

const en_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for every player`)
};

const es_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho para cada jugador`)
};

const de_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für jeden Spieler gemacht`)
};

const zh_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为每一位球员而设计`)
};

const ar_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مصمّم لكل لاعب`)
};

const fr_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conçu pour chaque joueur`)
};

const vi_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dành cho mọi người chơi`)
};

const sw_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imeundwa kwa kila mchezaji`)
};

const th_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ออกแบบมาเพื่อผู้เล่นทุกคน`)
};

const bs_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Građeno za svakog igrača`)
};

const ja_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのプレーヤーのために`)
};

const ko_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 선수를 위해`)
};

const pt_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito para cada jogador`)
};

const it_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensato per ogni giocatore`)
};

const sv_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggt för alla spelare`)
};

const nl_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemaakt voor elke speler`)
};

const da_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygget til alle spillere`)
};

const nb_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laget for alle spillere`)
};

const fi_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehty jokaiselle pelaajalle`)
};

const pl_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla każdego gracza`)
};

const ru_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для каждого игрока`)
};

const tr_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her oyuncu için tasarlandı`)
};

const hi_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हर खिलाड़ी के लिए बना`)
};

const id_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirancang untuk setiap pemain`)
};

const ms_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibina untuk setiap pemain`)
};

const cs_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro každého hráče`)
};

const el_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φτιαγμένο για κάθε παίκτη`)
};

const he_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מותאם לכל שחקן`)
};

const af_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebou vir elke speler`)
};

const hu_injury_built_for = /** @type {(inputs: Injury_Built_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden játékosnak készült`)
};

/**
* | output |
* | --- |
* | "Built for every player" |
*
* @param {Injury_Built_ForInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_built_for = /** @type {((inputs?: Injury_Built_ForInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Built_ForInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_built_for(inputs)
	if (locale === "de") return de_injury_built_for(inputs)
	if (locale === "zh") return zh_injury_built_for(inputs)
	if (locale === "ar") return ar_injury_built_for(inputs)
	if (locale === "fr") return fr_injury_built_for(inputs)
	if (locale === "vi") return vi_injury_built_for(inputs)
	if (locale === "sw") return sw_injury_built_for(inputs)
	if (locale === "th") return th_injury_built_for(inputs)
	if (locale === "bs") return bs_injury_built_for(inputs)
	if (locale === "ja") return ja_injury_built_for(inputs)
	if (locale === "ko") return ko_injury_built_for(inputs)
	if (locale === "pt") return pt_injury_built_for(inputs)
	if (locale === "it") return it_injury_built_for(inputs)
	if (locale === "sv") return sv_injury_built_for(inputs)
	if (locale === "nl") return nl_injury_built_for(inputs)
	if (locale === "da") return da_injury_built_for(inputs)
	if (locale === "nb") return nb_injury_built_for(inputs)
	if (locale === "fi") return fi_injury_built_for(inputs)
	if (locale === "pl") return pl_injury_built_for(inputs)
	if (locale === "ru") return ru_injury_built_for(inputs)
	if (locale === "tr") return tr_injury_built_for(inputs)
	if (locale === "hi") return hi_injury_built_for(inputs)
	if (locale === "id") return id_injury_built_for(inputs)
	if (locale === "ms") return ms_injury_built_for(inputs)
	if (locale === "cs") return cs_injury_built_for(inputs)
	if (locale === "el") return el_injury_built_for(inputs)
	if (locale === "he") return he_injury_built_for(inputs)
	if (locale === "af") return af_injury_built_for(inputs)
	if (locale === "hu") return hu_injury_built_for(inputs)
	return en_injury_built_for(inputs)
});